import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { MapPin, Mail, Shield, Building, Calendar } from 'lucide-react';
import { useClinicianStore } from '../store/clinicianStore';
import { useGroupStore } from '../store/groupStore';
import { VerifiedBadge } from '../components/verification/VerifiedBadge';
import { AppointmentRequestForm } from '../components/appointments/AppointmentRequestForm';
import ClinicianDetails from '../components/clinician/ClinicianDetails';

export const ClinicianProfilePage = () => {
  const { id } = useParams<{ id: string }>();
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);


  
  const group = useGroupStore((state) =>
    state.groups.find((g) => g.id === clinician?.groupId)
  );


  const handleAppointmentRequest = (data: {
    name: string;
    email: string;
    phone: string;
    additionalInfo: string;
  }) => {
    // In production, this would send the request to your backend
    setShowAppointmentForm(false);
    // Show success message or handle response
  };

  return (
    <>
      <ClinicianDetails clinician={clinician} />
      
      {showAppointmentForm && (
        <AppointmentRequestForm
          clinicianName={clinician.name}
          onClose={() => setShowAppointmentForm(false)}
          onSubmit={handleAppointmentRequest}
        />
      )}
    </>
  );
};
